export default {
      id: "video-event_no-driver-usage",
      viewBox: "0 0 40 40",
      url: __webpack_public_path__ + "img/icons.svg#video-event_no-driver",
      toString: function () {
        return this.url;
      }
    }